import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './index.css';

const DEFAULT_TITLE = 'Homphy | Physiotherapists Near You in Kenya | Pay with M-PESA';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// prerender.mjs writes a static <title> and OG <meta> tags for crawlers/SEO.
// react-helmet-async can only manage tags it created itself (marked
// data-rh="true"), so it cannot detect or replace those static ones --
// it just appends its own, causing duplicates. Strip the static ones
// here, before hydration, so Helmet gets a clean head to own.
document.querySelectorAll(
  'title, meta[property^="og:"], meta[name="description"], meta[name="robots"], script[type="application/ld+json"]'
).forEach((el) => el.remove());
document.title = DEFAULT_TITLE;

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet defaultTitle={DEFAULT_TITLE} />
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

